export const getQzConfig = () => ({
	printerName: 'Commercial_Invoices_Default',
	certificateBaseUrl: process.env.REACT_APP_CERT_BASEURL,
	signBaseUrl: process.env.REACT_APP_SIGN_BASEURL,
	shipmentLocation: process.env.REACT_APP_SHIPMNET_LOCATION,
	ciDocumentType: new RegExp(
		'^((bpost(-parcel)?-ci)|((\\w+-)?commercial-invoice.*))$'
	)
})

export const getSAPI = () => ({
	baseURL: process.env.REACT_APP_SAPI_BASE_URL
})



// WEBPACK FOOTER //
// ./src/config.js